import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ElmResponse } from '../shared';

export const responseError = <T>(src$: Observable<HttpErrorResponse>) =>
  src$.pipe(map(response => response.error as ElmResponse<T>));
